import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "../../shared/shared.module";
import { UiModule } from "../../ui/ui.module";
import { NotifyModule } from "../../notify/notify.module";
import { ClientContactPersonRepository } from "../client-contact-person-list/client-contact-person.repository";
import { ClientPotentialRepository } from "app/potential/client-potential.repository";
import { MultiSelectModule } from "primeng/multiselect";
import { ClientPotentialFormComponent } from "./client-potential-form.component";
import { DialogModule } from "primeng/dialog";

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    UiModule,
    NotifyModule,
    MultiSelectModule,
    DialogModule,
    ClientPotentialFormComponent,
  ],
  providers: [ClientContactPersonRepository, ClientPotentialRepository],
  exports: [ClientPotentialFormComponent],
})
export class ClientPotentialFormModule {}
